import React, { FC, ReactElement, MouseEvent } from 'react';
import classNames from 'classnames/bind';

import { useModal } from 'components/Modal/Modal.hooks';
import { RemoveModalProps } from 'components/Modal/Modal.types';

import styles from 'components/Modal/ModalTypes/RemoveModal/RemoveModal.module.scss';

const cn = classNames.bind(styles);

const RemoveModal: FC<RemoveModalProps> = ({ confirmRemoval }): ReactElement => {
  const { closeModal } = useModal();

  const cancelHandler = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    closeModal();
  };

  const confirmHandler = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    confirmRemoval();
    closeModal();
  };

  return (
    <div className={cn('remove-modal')}>

      <h4 className={cn('remove-modal__heading')}>
        Confirm removal
      </h4>

      <div className={cn('remove-modal__description')}>
        <p className={cn('remove-modal__description-paragraph')}>
          Remove this item?
        </p>
      </div>

      <div className={cn('remove-modal__buttons')}>
        <button
          className={cn('remove-modal__button-cancel')}
          onClick={cancelHandler}
        >
          Cancel
        </button>

        <button
          className={cn('remove-modal__button-delete')}
          onClick={confirmHandler}
        >
          Remove
        </button>
      </div>

    </div>
  );
};

export { RemoveModal };